import React from 'react';
import { useTranslation } from 'react-i18next';
import ErrorPage from '../utils/ErrorPage';

const ErrorPageWrapper = ({ code, title, message }) => {
  const { t } = useTranslation();
  
  // Traductions pour les messages d'erreur courants
  const getTranslatedMessage = () => {
    if (code === 404) {
      return t('error.linkInvalid', 'Le lien que vous utilisez n\'est pas valide ou a expiré. Veuillez utiliser le lien original qui vous a été envoyé.');
    }
    return message;
  };

  return (
    <ErrorPage 
      code={code} 
      title={title || t('error.pageNotFound', 'Page introuvable')} 
      message={getTranslatedMessage()} 
    />
  );
};

export default ErrorPageWrapper;
